import { UIHeading2, Image } from '@cian/ui-kit';
import React from 'react';
import { ActionButton } from '../ActionButton';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Success = function Success(_ref) {
  var onButtonClick = _ref.onButtonClick,
    message = _ref.message;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['success'],
    "data-testid": "leave-contacts-modal-success",
    children: [/*#__PURE__*/_jsx(Image, {
      src: "https://cdn.cian.site/frontend/e2e-form-assets/partner_rewards/other/call-me.png",
      width: 80,
      height: 80
    }), /*#__PURE__*/_jsx(UIHeading2, {
      textAlign: "center",
      whiteSpace: "pre-line",
      children: message
    }), /*#__PURE__*/_jsx(ActionButton, {
      onClick: onButtonClick,
      type: "button",
      theme: "fill_primary",
      "data-testid": "leave-contacts-modal-success-button",
      children: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E"
    })]
  });
};